import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../../public/package.json'
import {HeaderComponent} from './1-components/header/header.component'

@Component({
  selector: 'spb-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  public configService = inject(ConfigService)
  public version = version.version
}
